const STAR_COLOR = '#1D1D1D';
const STAR_PATH = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';

const svg = (inner) =>
  `<svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${inner}</svg>`;

let gradientCount = 0;

const buildStars = (rating) => {
  const uid = gradientCount++;
  return Array.from({ length: 5 }, (_, i) => {
    const full = rating >= i + 1, half = !full && rating >= i + 0.5;
    if (full) return svg(`<path d="${STAR_PATH}" fill="${STAR_COLOR}"/>`);
    if (half) return svg(`<defs><linearGradient id="s${uid}-${i}" x1="0" x2="1" y1="0" y2="0"><stop offset="50%" stop-color="${STAR_COLOR}"/><stop offset="50%" stop-color="#E8E8E8"/></linearGradient></defs><path d="${STAR_PATH}" fill="url(#s${uid}-${i})"/>`);
    return svg(`<path d="${STAR_PATH}" fill="#E8E8E8"/>`);
  }).join('');
};

// Elements waiting for their rating data, keyed by product ID.
// Multiple elements can share a product ID (e.g. same product in two carousels).
const pendingElements = new Map();
let fetchQueued = false;

function queueElement(productId, el) {
  if (!pendingElements.has(productId)) pendingElements.set(productId, new Set());
  pendingElements.get(productId).add(el);
  if (fetchQueued) return;
  fetchQueued = true;
  // Defer until after all connectedCallbacks in this tick have registered,
  // so we can fetch all product ratings in a single request.
  setTimeout(fetchAndRenderRatings, 0);
}

async function fetchAndRenderRatings() {
  fetchQueued = false;
  const waiting = new Map(pendingElements);
  pendingElements.clear();

  const publicKey = window.Theme?.klaviyoPublicKey;
  if (!publicKey || !waiting.size) return;

  try {
    const res = await fetch(
      `https://fast.a.klaviyo.com/reviews/api/client_reviews/?company_id=${publicKey}&products=${encodeURIComponent(JSON.stringify([...waiting.keys()]))}`
    );
    if (!res.ok) return;
    const { products = [] } = await res.json();
    for (const p of products) {
      const id = String(p.external_id ?? p.id ?? '');
      const rating = p.star_rating ?? p.summary?.star_rating;
      const count = p.review_count ?? p.summary?.review_count;
      if (count) waiting.get(id)?.forEach(el => el.show(rating, count));
    }
  } catch {}
}

class ProductStarRating extends HTMLElement {
  #queued = false;

  connectedCallback() {
    if (this.#queued) return;
    this.#queued = true;
    const { productId } = this.dataset;
    if (productId) queueElement(productId, this);
  }

  show(rating, count) {
    const label = `${count.toLocaleString('en-GB')} ${count === 1 ? 'review' : 'reviews'}`;
    this.innerHTML = `<div class="flex items-center gap-2"><div class="flex">${buildStars(rating)}</div><span class="alt-body-tiny text-muted-black">${label}</span></div>`;
    this.removeAttribute('hidden');
  }
}

customElements.define('product-star-rating', ProductStarRating);
